module.exports = __webpack_public_path__ + "static/cs11-9ca05183721bc6cb8ab9a49eb0296799.jpg";